import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined'
import { Alert } from '@mui/material'

import {
  COLOR_NO_INTERVENTION,
  JOBS_WITHOUT_INTERVENTION_INFO,
} from 'components/reports/Metrics/constants/ExceptionMetrics'
import { useGetExceptionMetricsJobsCompletedWithoutInterventionQuery } from 'generated/graphql'

import { MetricCard } from '../components'
import { useExceptionMetricsQueryInput } from './useExceptionMetricsQueryInput'

export const JobsCompletedWithoutInterventionMetricCard = () => {
  const { hasValidRange, input } = useExceptionMetricsQueryInput()

  const { data, previousData, loading, error } =
    useGetExceptionMetricsJobsCompletedWithoutInterventionQuery({
      variables: { input },
      skip: !hasValidRange,
      notifyOnNetworkStatusChange: true,
      nextFetchPolicy: 'cache-and-network',
    })

  const series =
    data?.exceptionMetricsJobsCompletedWithoutIntervention ??
    previousData?.exceptionMetricsJobsCompletedWithoutIntervention

  if (error) {
    return (
      <Alert severity='error'>
        Failed to load jobs completed without admin intervention metric. Please try again.
      </Alert>
    )
  }

  return (
    <MetricCard
      title='Jobs completed without admin intervention'
      countCaption='Jobs without intervention'
      tooltipLabel='Without intervention'
      color={COLOR_NO_INTERVENTION}
      icon={<TaskAltOutlinedIcon fontSize='small' />}
      info={JOBS_WITHOUT_INTERVENTION_INFO}
      series={series}
      loading={loading && !series}
    />
  )
}
